import React from 'react';

interface DialogAlertProps {
  show: boolean;
  message?: string;
  testId?: string;
}

export default function DialogAlert({ show, message = 'Please fix the highlighted fields.', testId }: DialogAlertProps) {
  if (!show) return null;

  return (
    <div className="alert error" role="alert" aria-live="assertive" data-testid={testId}>
      {message}
    </div>
  );
}
